module.exports = __webpack_public_path__ + "assets/img/ad_car.2764c40b.png";